import { useParams } from 'react-router-dom';
import { Screen } from '../components/Screen';
import { AppHeader } from '../components/AppHeader';
import { Spinner } from '../components/Spinner';
import { EditorProvider } from '../editor/EditorContext';
import { EditorView } from '../editor/EditorView';
import { useAgenda } from '../api/queries';
import { AccountMenu } from '../auth/AccountMenu';

export function EditorScreen() {
  const { id = '' } = useParams();
  // useAgenda always mounts against fresh server state (gcTime: 0 +
  // refetchOnMount: 'always'), so the draft seeded here reflects what is
  // actually persisted, never a stale cache entry from a prior visit.
  const { data, isLoading, isError, error, refetch } = useAgenda(id);

  if (isLoading) {
    return (
      <Screen header={<AppHeader title="Loading…" back="/" actions={<AccountMenu />} />}>
        <Spinner />
      </Screen>
    );
  }

  if (isError || !data) {
    return (
      <Screen header={<AppHeader title="Agenda" back="/" actions={<AccountMenu />} />}>
        <div className="state-center">
          <div className="state-icon">⚠️</div>
          <h2>Couldn’t load agenda</h2>
          <p>{(error as Error)?.message}</p>
          <button className="btn" onClick={() => refetch()}>
            Retry
          </button>
        </div>
      </Screen>
    );
  }

  // Re-key on id so switching agendas re-initializes the draft.
  return (
    <EditorProvider key={data.id} initial={data}>
      <EditorView />
    </EditorProvider>
  );
}
